export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      portfolio: 'Portfolio',
      testimonials: 'Testimonials',
      contact: 'Contact',
      blog: 'Blog',
    },
    hero: {
      title: 'Welcome to Fortino Tech',
      subtitle: 'Transforming Ideas into Powerful Digital Solutions. Web Development, Mobile Apps, Graphics Design, and More.',
      cta: 'Contact Us',
    },
    about: {
      title: 'About Us',
      description1: 'Fortino Tech is a leading technology company dedicated to delivering innovative solutions that transform businesses and empower digital transformation.',
      description2: 'With over 3 years of experience, we have successfully completed 50+ projects for clients across various industries, helping them achieve their digital goals.',
      description3: 'Our team of talented professionals is committed to delivering high-quality solutions that exceed expectations and drive growth.',
      feature1: 'Expert Team',
      feature1Desc: 'Skilled professionals with years of experience',
      feature2: 'Quality Assurance',
      feature2Desc: 'Rigorous testing and quality control processes',
      feature3: 'Customer Support',
      feature3Desc: '24/7 support available for all clients',
    },
    services: {
      title: 'Our Services',
      webDev: 'Web Development',
      webDevDesc: 'Custom websites and web applications built with modern technologies',
      appDev: 'Application Development',
      appDevDesc: 'Mobile and desktop applications tailored to your needs',
      graphicDesign: 'Graphics Design',
      graphicDesignDesc: 'Creative visual design for brands and marketing materials',
      digitalMarketing: 'Digital Marketing',
      digitalMarketingDesc: 'Strategic marketing to grow your online presence',
      itConsultancy: 'IT Consultancy',
      itConsultancyDesc: 'Expert advice on technology solutions and strategies',
      cctv: 'CCTV Camera Installation',
      cctvDesc: 'Professional CCTV camera installation, configuration, remote viewing setup, and maintenance for offices, homes, clinics, and commercial buildings.',
    },
    servicePage: {
      learnMore: 'View details',
      back: 'Back to services',
      overview: 'Overview',
      gallery: 'Images from this service',
      related: 'Other services',
      duration: 'Typical duration',
      timeline: 'Typical timeline',
      requirements: 'What we need to implement',
      ctaTitle: 'Ready to start this project?',
      ctaText: 'Tell us what you need. We will reply with a clear plan and a realistic timeline.',
      ctaButton: 'Discuss this project',
      notFound: 'This service was not found.',
    },
    blog: {
      title: 'News & Insights',
      featuredTitle: 'Featured News',
      badge: 'Insights',
      readMore: 'Read more',
      viewAll: 'View all articles',
      back: 'Back to news',
    },
    portfolio: {
      title: 'Recent Portfolio',
      viewProject: 'View Project',
    },
    testimonials: {
      title: 'What Our Clients Say',
      person1: 'Tewdros Ayele',
      company1: 'ABC Corporation',
      text1: 'Fortino Tech delivered an outstanding solution for our business. The team was professional, reliable, and delivered on time.',
      person2: 'Dr Biniam',
      company2: 'XYZ Startup',
      text2: 'Exceptional service and quality. They understood our vision and brought it to life beautifully.',
      person3: 'Setsemichael Guchima',
      company3: 'Tech Solutions Inc',
      text3: 'Working with Fortino Tech was a game-changer for our company. Highly recommended! Great results delivered.',
      person4: 'Mireaf Daniel',
      company4: 'Digital Agency',
      text4: 'The professionalism and expertise of the team are unmatched. Great results delivered. Highly recommended!',
      person5: 'Meron Dagne',
      company5: 'Enterprise Corp',
      text5: 'Fortino Tech provided exactly what we needed. Outstanding communication and delivery.',
      person6: 'Emebet wolde',
      company6: 'Creative Studio',
      text6: 'Incredible team with deep technical knowledge. Would work with them again in a heartbeat.',
      person7: 'Tigist Jira',
      company7: 'Marketing Group',
      text7: 'Professional, innovative, and results-driven. Fortino Tech exceeded our expectations.',
      person8: 'melaku tarekegn',
      company8: 'E-Commerce Plus',
      text8: 'Fantastic experience from start to finish. Highly skilled developers.',
      person9: 'Abreham Debebe',
      company9: 'Tech Ventures',
      text9: 'Outstanding quality and attention to detail. Great team to work with.',
      person10: 'Yishareg Tulu',
      company10: 'Business Solutions',
      text10: 'Fortino Tech delivered a solution that perfectly matched our requirements.',
    },
    partners: {
      title: 'Our Partners',
    },
    statistics: {
      title: 'Our Statistics',
      projects: 'Projects Completed',
      clients: 'Happy Clients',
      experience: 'Years Experience',
      support: 'Support Available',
    },
    contact: {
      title: 'Get In Touch',
      description: 'Have a project in mind? Get in touch with us and let\'s create something amazing together.',
      address: 'Addis Ababa, Jemo Michael, Peony Commercial Building, Office No. 306/A',
      form: {
        name: 'Full Name',
        namePlaceholder: 'Your full name',
        email: 'Email Address',
        emailPlaceholder: 'your.email@example.com',
        phone: 'Phone Number',
        phonePlaceholder: '+251 9XX XXX XXXX',
        subject: 'Subject',
        subjectPlaceholder: 'What is this about?',
        message: 'Message',
        messagePlaceholder: 'Tell us about your project...',
      },
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent successfully! We\'ll get back to you soon.',
      error: 'Failed to send message. Please try again.',
    },
    chatbot: {
      title: 'Fortino AI Assistant',
      q1: 'What services do you offer?',
      a1: 'We offer web development, mobile app development, graphics design, digital marketing, and IT consultancy services.',
      q2: 'How long does a typical project take?',
      a2: 'Project timelines vary based on scope and complexity. We provide detailed timelines after understanding your requirements.',
      q3: 'Do you provide support after project completion?',
      a3: 'Yes! We offer 24/7 support for all our clients to ensure smooth operation of your digital solutions.',
      q4: 'What technologies do you use?',
      a4: 'We use modern and industry-standard technologies including React, Node.js, Python, and more.',
      q5: 'Can you work with our existing systems?',
      a5: 'Absolutely! We can integrate our solutions with your existing systems and workflows.',
      q6: 'How much do your services cost?',
      a6: 'Pricing depends on project requirements. We offer competitive rates and flexible payment options. Contact us for a quote.',
      q7: 'Do you offer maintenance services?',
      a7: 'Yes, we provide ongoing maintenance and updates to keep your systems running smoothly.',
      q8: 'What is your process for project development?',
      a8: 'We follow an agile development process with regular communication, milestones, and iterative improvements.',
      q9: 'Can you help with hosting and deployment?',
      a9: 'Yes, we can assist with hosting setup, deployment, and ensure your solution is live and secure.',
      q10: 'How do I get started with Fortino Tech?',
      a10: 'Simply contact us through our form or Facebook page, and we\'ll schedule a consultation to discuss your project.',
    },
    footer: {
      description: 'Transforming businesses through innovative technology solutions.',
      quickLinks: 'Quick Links',
      contact: 'Contact Info',
      facebook: 'Facebook',
      copyright: 'Copyright',
      allRights: 'All rights reserved.',
    },
  },
  am: {
    nav: {
      home: 'ዋና ገጽ',
      about: 'ስለ እኛ',
      services: 'አገልግሎቶች',
      portfolio: 'ፕሮጀክቶች',
      testimonials: 'ምስክርነት',
      contact: 'ያግኙን',
      blog: 'ብሎግ',
    },
    hero: {
      title: 'ወደ ፎርቲኖ ቴክ እንኳን በደህና መጡ',
      subtitle: 'የድረ-ገጽ ልማት (Web Development)፣ የሞባይል መተግበሪያዎች (Mobile Apps)፣ የግሬፊክስ ዲዛይን እና ሌሎችም የቴክኖሎጂ አገልግሎቶች።',
      cta: 'ያግኙን',
    },
    about: {
      title: 'ስለ እኛ',
      description1: 'ፎርቲኖ ቴክ የንግድ ተቋማትን አሰራር የሚያዘምኑና የዲጂታል ሽግግርን የሚያፋጥኑ የፈጠራ ውጤቶችን በማቅረብ ላይ የሚገኝ ተቋም ነው። ',
      description2: 'ባለፉት 3 ዓመታት ባካበትነው ልምድ፣ በተለያዩ ዘርፎች ለተሰማሩ ደንበኞቻችን ከ50 በላይ ፕሮጀክቶችን በተሳካ ሁኔታ በማጠናቀቅ የዲጂታል ግባቸውን እንዲያሳኩ ረድተናል።',
      description3: 'ባለክህሎት የሆኑ የቡድን አባሎቻችን፣ የደንበኞቻችንን እቅድ የሚያሳኩ፣ ከጠበቁት በላይ የሆኑና ለንግድ እድገታቸው ጉልህ አስተዋጽኦ የሚያበረክቱ ጥራት ያላቸው የቴክኖሎጂ መፍትሄዎችን ለማቅረብ ቁርጠኛ ናቸው።',
      feature1: 'ባለሙያ ቡድን',
      feature1Desc: 'የብዙ ዓመታት ልምድ ያካበቱና ከፍተኛ ብቃት ያላቸው ባለሙያዎች።',
      feature2: 'አስተማማኝ ጥራት',
      feature2Desc: 'ጥብቅ የሆኑ የጥራት ቁጥጥርና የሙከራ ሂደቶችን ተግባራዊ እናደርጋለን።',
      feature3: 'የደንበኞች ድጋፍ',
      feature3Desc: 'ለሁሉም ደንበኞቻችን በ24/7 የድጋፍ አገልግሎት ዝግጁ ነን።',
    },
    services: {
      title: 'አገልግሎቶቻችን',
      webDev: 'የድረ-ገጽ ልማት',
      webDevDesc: 'ዘመናዊ ቴክኖሎጂዎችን በመጠቀም እንደ ፍላጎቶ የሚሰሩ ድረ-ገጾች እና የዌብ መተግበሪያዎች',
      appDev: 'የመተግበሪያዎች ልማት',
      appDevDesc: 'ለእርስዎ ፍላጎት ተስማሚ የሆኑ የሞባይል እና የዴስክቶፕ መተግበሪያዎች',
      graphicDesign: 'የግራፊክስ ዲዛይን',
      graphicDesignDesc: 'ለብራንድዎ እና ለማስታወቂያ ስራዎችዎ የሚሆኑ የፈጠራ የታከለባቸው የእይታ ስራዎች',
      digitalMarketing: 'ዲጂታል ግብይት',
      digitalMarketingDesc: 'የተቋምዎን ዲጂታል ተደራሽነት ለማሳደግ የሚረዱ ስልታዊ የግብይት ስራዎች',
      itConsultancy: 'የአይቲ አማካሪነት',
      itConsultancyDesc: 'በቴክኖሎጂ መፍትሄዎች እና ስልቶች ላይ የሚሰጥ የባለሙያ ምክር',
      cctv: 'የCCTV ካሜራ ተከላ',
      cctvDesc: 'ለቢሮ፣ ለቤት፣ ለክሊኒክ እና ለንግድ ተቋማት የCCTV ካሜራ ተከላ፣ ማስተካከል፣ የርቀት እይታ እና ጥገና።',
    },
    servicePage: {
      learnMore: 'ዝርዝር ይመልከቱ',
      back: 'ወደ አገልግሎቶች ተመለስ',
      overview: 'አጠቃላይ መግለጫ',
      gallery: 'የዚህ አገልግሎት ምስሎች',
      related: 'ሌሎች አገልግሎቶች',
      duration: 'የሚወስደው ጊዜ',
      timeline: 'የተለመደ የጊዜ ሰሌዳ',
      requirements: 'ለመተግበር የሚያስፈልገን',
      ctaTitle: 'ይህን ፕሮጀክት ለመጀመር ዝግጁ ነዎት?',
      ctaText: 'የሚፈልጉትን ይንገሩን። ግልጽ እቅድ እና እውነተኛ የጊዜ ሰሌዳ እንልክልዎታለን።',
      ctaButton: 'ስለዚህ ፕሮጀክት ይነጋገሩ',
      notFound: 'ይህ አገልግሎት አልተገኘም።',
    },
    blog: {
      title: 'ዜና እና ጽሑፎች',
      featuredTitle: 'ተለይተው የቀረቡ ዜናዎች',
      badge: 'ዜና',
      readMore: 'ተጨማሪ ያንብቡ',
      viewAll: 'ሁሉንም ጽሑፎች ይመልከቱ',
      back: 'ወደ ዜና ተመለስ',
    },
    portfolio: {
      title: 'በቅርቡ የተሰሩ ስራዎች',
      viewProject: 'ፕሮጀክቱን ይመልከቱ',
    },
    testimonials: {
      title: 'የደንበኞቻችን ምስክርነት',
      person1: 'Dr Biniam ',
      company1: 'ABC Corporation',
      text1: 'ፎርቲኖ ቴክ ለድርጅታችን አስደናቂ መፍትሄ አቅርቧል። ቡድኑ ሙያዊ ብቃት ያለው፣ ታማኝ እና ስራውን በወቅቱ የሚያስረክብ ነው።',
      person2: 'Setsemichael Guchima',
      company2: 'XYZ Startup',
      text2: 'ልዩ አገልግሎት እና ጥራት! ራዕያችንን በሚገባ በመረዳት ወደ እውነታ ቀይረውታል። በእጅጉ እንመክራቸዋለን!',
      person3: 'Mireaf Daniel',
      company3: 'Tech Solutions Inc',
      text3: 'ከፎርቲኖ ቴክ ጋር መስራት ለድርጅታችን ትልቅ ለውጥ ያመጣ ነበር። በእጅጉ እንመክራቸዋለን!',
      person4: 'Meron Dagne',
      company4: 'Digital Agency',
      text4: 'የቡድኑ ሙያዊ ስነ-ምግባር እና ክህሎት ወደር የለውም። ምርጥ ውጤት አስመዝግበዋል።',
      person5: 'Emebet wolde',
      company5: 'Enterprise Corp',
      text5: 'ፎርቲኖ ቴክ ልክ የሚያስፈልገንን ነገር አቅርቦልናል። አስደናቂ የሐሳብ ልውውጥ እና አሰጣጥ አላቸው።',
      person6: 'Tigist Jira',
      company6: 'Creative Studio',
      text6: 'ጥልቅ የቴክኒክ እውቀት ያለው የሚገርም ቡድን። ዳግመኛ ከእነሱ ጋር ለመስራት ወደኋላ አልልም።',
      person7: 'melaku tarekegn',
      company7: 'Marketing Group',
      text7: 'ሙያዊ፣ ፈጣሪ እና ውጤት ተኮር። ፎርቲኖ ቴክ ከጠበቅነው በላይ ስራዎችን አከናውኗል።',
      person8: 'Abreham Debebe',
      company8: 'E-Commerce Plus',
      text8: 'ከመጀመሪያ እስከ መጨረሻ ድንቅ ልምድ ነበር። በጣም ከፍተኛ ክህሎት ያላቸው አልሚዎች (Developers) ናቸው።',
      person9: 'Yishareg Tulu',
      company9: 'Tech Ventures',
      text9: 'አስደናቂ ጥራት እና ለዝርዝር ነገሮች የሚሰጡት ትኩረት ይገርማል። አብሮ ለመስራት ምርጥ ቡድን።',
      person10: 'Patricia Taylor',
      company10: 'Business Solutions',
      text10: 'ፎርቲኖ ቴክ ከፍላጎታችን ጋር በትክክል የሚጣጣም መፍትሄ አቅርቦልናል።',
    },
    partners: {
      title: 'አጋሮቻችን',
    },
    statistics: {
      title: 'ቁልፍ መረጃዎች',
      projects: 'የተጠናቀቁ ፕሮጀክቶች',
      clients: 'ደንበኞች',
      experience: 'የዓመታት ልምድ',
      support: 'የድጋፍ አገልግሎት',
    },
    contact: {
      title: 'ያግኙን',
      description: 'በአእምሮዎ የያዙት ፕሮጀክት አለ? ይምጡና አብረን አስደናቂ ነገር እንፍጠር።',
      address: 'አዲስ አበባ፣ ጀሞ ሚካኤል፣ ፒዮኒ ኮመርሻል ቪልዲንግ፣ ቢሮ ቁጥር 306/A',
      form: {
        name: 'ሙሉ ስም',
        namePlaceholder: 'ሙሉ ስምዎን እዚህ ያስገቡ',
        email: 'የኢሜል አድራሻ',
        emailPlaceholder: 'የእርስዎ.ኢሜል@ምሳሌ.com',
        phone: 'የስልክ ቁጥር',
        phonePlaceholder: '+251 9XX XXX XXXX',
        subject: 'ጉዳዩ',
        subjectPlaceholder: 'ስለ ምን መነጋገር ይፈልጋሉ?',
        message: 'መልዕክት',
        messagePlaceholder: 'ስለ ፕሮጀክትዎ በጥቂቱ ይንገሩን...',
      },
      send: 'መልዕክት ላክ',
      sending: 'በመላክ ላይ...',
      success: 'መልዕክትዎ በተሳካ ሁኔታ ተልኳል! በቅርቡ እናገኝዎታለን።',
      error: 'መልዕክቱን መላክ አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    },
    chatbot: {
      title: 'የፎርቲኖ AI ረዳት',
      q1: 'ምን ዓይነት አገልግሎቶችን ትሰጣላችሁ?',
      a1: 'የድረ-ገጽ ልማት፣ የሞባይል መተግበሪያ ልማት፣ የግራፊክስ ዲዛይን፣ ዲጂታል ግብይት እና የአይቲ አማካሪነት አገልግሎቶችን እንሰጣለን።',
      q2: 'አንድ ፕሮጀክት ለመጨረስ ምን ያህል ጊዜ ይወስዳል?',
      a2: 'እንደ ፕሮጀክቱ ስፋትና ውስብስብነት ይለያያል። ፍላጎትዎን ከተረዳን በኋላ ዝርዝር የጊዜ ሰሌዳ እንሰጥዎታለን።',
      q3: 'ፕሮጀክቱ ከተጠናቀቀ በኋላ ድጋፍ ትሰጣላችሁ?',
      a3: 'አዎ! የፈጠርናቸው ዲጂታል መፍትሄዎች ያለምንም ችግር መስራታቸውን ለማረጋገጥ ለሁሉም ደንበኞቻችን የ24/7 የድጋፍ አገልግሎት እንሰጣለን።',
      q4: 'ምን ዓይነት ቴክኖሎጂዎችን ትጠቀማላችሁ?',
      a4: 'እንደ React፣ Node.js፣ Python እና ሌሎች ዘመናዊና በዘርፉ ተመራጭ የሆኑ ቴክኖሎጂዎችን እንጠቀማለን።',
      q5: 'ካሉን ነባር ሲስተሞች ጋር አብሮ መስራት ትችላላችሁ?',
      a5: 'በእርግጥ! የምናዘጋጃቸውን መፍትሄዎች አሁን ካሉዎት ሲስተሞች እና የስራ ሂደቶች ጋር ማቀናጀት እንችላለን።',
      q6: 'የአገልግሎቶቻችሁ ዋጋ ስንት ነው?',
      a6: 'ዋጋው እንደ ፕሮጀክቱ ፍላጎት ይወሰናል። ተመጣጣኝ ዋጋ እና ተለዋዋጭ የክፍያ አማራጮችን እናቀርባለን። ለዋጋ ዝርዝር እባክዎን ያግኙን።',
      q7: 'የጥገና (Maintenance) አገልግሎት ትሰጣላችሁ?',
      a7: 'አዎ፣ ሲስተምዎ ሁል ጊዜ በትክክል እንዲሰራ ቀጣይነት ያለው የጥገና እና የማሻሻያ አገልግሎት እንሰጣለን።',
      q8: 'የፕሮጀክት ልማት ሂደታችሁ ምን ይመስላል?',
      a8: 'መደበኛ ግንኙነትን፣ የደረጃ በደረጃ ስራዎችን እና ተከታታይ ማሻሻያዎችን ያካተተ ቀልጣፋ (Agile) የልማት ሂደትን እንከተላለን።',
      q9: 'ድረ-ገጾችን ወደ ኢንተርኔት የማውጣት (Hosting and Deployment) ስራ ላይ ትረዳላችሁ?',
      a9: 'አዎ፣ የሆስቲንግ ዝግጅቶችን፣ ስራውን ወደ ኢንተርኔት የማውጣት እና ደህንነቱ የተጠበቀ እንዲሆን የማድረግ ስራ እንሰራለን።',
      q10: 'ከፎርቲኖ ቴክ ጋር ስራ ለመጀመር ምን ማድረግ አለብኝ?',
      a10: 'በድረ-ገጻችን ባለው ቅጽ ወይም በፌስቡክ ገጻችን ያግኙን፤ ስለ ፕሮጀክትዎ ለመወያየት ቀጠሮ እንይዛለን።',
    },
    footer: {
      description: 'በፈጠራ የታከለባቸው የቴክኖሎጂ መፍትሄዎች የንግድ ተቋማትን እናዘምናለን።',
      quickLinks: 'ፈጣን ሊንኮች',
      contact: 'የመገናኛ መረጃ',
      facebook: 'ፌስቡክ',
      copyright: 'የቅጂ መብት',
      allRights: 'መብቱ በህግ የተጠበቀ ነው።',
    },
  },
}
